export default "__VITE_ASSET__3773c830__"